import graphql from "babel-plugin-relay/macro";

const AllPollParticipationQuery = graphql`
query AllPollParticipationQuery{
  allPollsParticipants{
    edges{
      node{
        answer{
          id
        }
      }
    }
  }
}
`

export default AllPollParticipationQuery
